<template>
  <div
    v-if="isVisible"
    :class="bannerClass"
    class="flex items-center justify-center px-4 py-3 text-center hidden-print"
    role="status"
    aria-live="polite"
  >
    <span class="font-medium break-words">
      {{ banner.message }}
    </span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

const SEVERITY_CLASSES = {
  info: "bg-blue-400 text-white",
  warning: "bg-yellow-500 text-white",
  error: "bg-red-600 text-white",
};

export default {
  name: "SystemBanner",
  computed: {
    ...mapGetters({
      banner: "settings/systemBanner",
    }),
    isVisible() {
      return !!this.banner?.active && !!this.banner?.message;
    },
    bannerClass() {
      return SEVERITY_CLASSES[this.banner?.severity] || SEVERITY_CLASSES.info;
    },
  },
};
</script>
